// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import React, { memo } from "react";

const Eraser = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="13">
            <path
                fill="currentColor"
                d="M8.2734375 2.241406C8.0531254 2.0210936 7.6968746 2.0210936 7.4789066 2.241406L4.8773441 4.8429685L9.1546879 9.125L11.75625 6.5234375C11.976562 6.3031254 11.976562 5.9468746 11.75625 5.7289066L8.2734375 2.241406ZM1.741406 7.9765625C1.5210932 8.1968746 1.5210932 8.5531254 1.741406 8.7710934L3.803906 10.833593C3.9093747 10.939062 4.0523434 10.997656 4.2023435 10.997656L7.0476561 10.997656C7.1976562 10.997656 7.3406248 10.939062 7.4460936 10.833593L8.625 9.6546879L4.3453121 5.375L1.741406 7.9765625ZM6.9468746 1.711719C7.4601555 1.1984372 8.2898426 1.1984372 8.8031244 1.711719L12.28828 5.1968746C12.801562 5.710156 12.801562 6.5398436 12.28828 7.0531244L8.3414059 11L12.375 11C12.581249 11 12.75 11.168751 12.75 11.375C12.75 11.581249 12.581249 11.75 12.375 11.75L7.1249995 11.75L7.1249995 11.747656C7.0992184 11.75 7.0734367 11.75 7.0476561 11.75L4.2023435 11.75C3.8531249 11.75 3.5203121 11.611719 3.2742186 11.365625L1.2117187 9.3031254C0.69843757 8.7898445 0.69843757 7.9601564 1.2117187 7.4468756L6.9468746 1.711719Z"
            />
        </svg>
    );
};

export default memo(Eraser);
